module.exports = __webpack_public_path__ + "img/reload_icon.0eb7d331.svg";